export default {"src":"/_next/static/media/golf-max.1bf190e3.svg","height":32,"width":85,"blurWidth":0,"blurHeight":0};